import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

const KnowledgeChatLoader = (props: IContentLoaderProps) => {
  return (
    <ContentLoader
      speed={2}
      width="100%" // Let it fill parent width
      height={700} // Fixed rendered height
      viewBox="0 0 350 700" // Numeric viewBox
      preserveAspectRatio="xMinYMin meet" // Anchor shapes to top-left
      backgroundColor="#00000017"
      foregroundColor="#00000030"
      {...props}
    >
      {/* 
        LEFT COLUMN (approx. 320px width)
      */}
      <rect x="40" y="60" rx="20" ry="20" width="290" height="80" />
      <rect x="40" y="150" rx="20" ry="20" width="290" height="80" />
      <rect x="40" y="240" rx="20" ry="20" width="290" height="80" />
      <rect x="40" y="330" rx="20" ry="20" width="290" height="80" />
      <rect x="40" y="420" rx="20" ry="20" width="290" height="80" />
      <rect x="40" y="510" rx="20" ry="20" width="290" height="80" />
    </ContentLoader>
  );
};

export default KnowledgeChatLoader;
